module.exports = __webpack_public_path__ + "img/selected3-min.e5c082d1.png";